import { render, staticRenderFns } from "./SyncView.vue?vue&type=template&id=7cc44e2a&scoped=true&"
import script from "./SyncView.vue?vue&type=script&lang=js&"
export * from "./SyncView.vue?vue&type=script&lang=js&"
import style0 from "./SyncView.vue?vue&type=style&index=0&id=7cc44e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc44e2a",
  null
  
)

export default component.exports